(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-toggle-your-bet-button.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-toggle-your-bet-button.js');
"use strict";


const {
  yourbet
} = svs.sportsbook.sbtech_api_impl;
svs.sportsbook.sbtech_api_impl.fns.requests.sbtech_toggleYourBetButton = () => isOpen => {
  yourbet.setIsYourBetOpen(isOpen);
};

 })(window);